<template>
  <div class="quiz-page" v-if="page">
    <quiz-item :quiz="page" v-if="page.is_quiz" />
    <page-item :page="page" v-else />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PageItem from './PageItem';
import QuizItem from './QuizItem';

function preFetch(store) {
  return store.dispatch('fetchPages', store.getters.getRouteParams.page);
}

export default {
  name: 'page-show',

  props: [
    'cardId',
  ],

  components: {
    PageItem,
    QuizItem,
  },

  computed: {
    ...mapGetters({
      page: 'getPage',
      quizSolved: 'getQuizSolved',
    }),
  },

  methods: {
    ...mapActions({
      fetchPages: 'fetchPages',
    }),
  },

  preFetch,
};
</script>

<style lang="scss">
  .quiz-page {
    background-color: #ffffff;
    padding-bottom: 84px;
  }
</style>
